import {
  AgencyRadioComponent,
  CheckBoxComponent,
  DatePickerComponent,
  FileUploaderComponent,
  InputComponent,
  SelectComponent,
  TextAreaComponent,
} from 'src/components/common/ReactHookForm/view'
import { ReactNode } from 'react'
import styled, { RuleSet } from 'styled-components'

export const ReactHookFc = {
  Input: InputComponent,
  DatePicker: DatePickerComponent,
  FileUploader: FileUploaderComponent,
  AgencyRadio: AgencyRadioComponent,
  CheckBox: CheckBoxComponent,
  Select: SelectComponent,
  TextArea: TextAreaComponent,
}

export const ReactHookForm = ({
  children,
  onSubmit,
  style,
}: {
  children: ReactNode
  onSubmit?: any
  style?: RuleSet<object>
}) => {
  return (
    <FormStyle onSubmit={onSubmit} $style={style}>
      {children}
    </FormStyle>
  )
}

const FormStyle = styled.form<{ $style?: RuleSet<object> }>`
  width: 100%;
  ${(props) => props.$style};
`
